export default "__VITE_ASSET__Btkse3pU__"